import * as Toastr from "toastr";

export class ShippingConfirmations {
    static confirmShopifyAndShip(
        onConfirm: () => Promise<void>,
        onCancel?: () => void
    ): Promise<void> {
        return new Promise<void>((resolve) => {
            (window as any).swal({
                title: 'Are you sure?',
                text: 'Are you sure open in Shopify and mark as shipped?',
                icon: "warning",
                closeOnClickOutside: false,
                className: "sn-m-modal",
                buttons: {
                    cancel: {
                        text: "No",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true
                    },
                    confirm: {
                        text: "Yes",
                        value: true,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-red",
                        closeModal: true
                    }
                },
                dangerMode: true,
            }).then(async (willProceed: boolean) => {
                if (!willProceed) {
                    if (onCancel) onCancel();
                    resolve();
                    return;
                }

                try {
                    await onConfirm();
                } catch (error) {
                    Toastr.error("Asset not found", {
                        timeOut: 3000,
                        positionClass: 'toast-top-right'
                    });
                }
                resolve();
            });
        });
    }

    static confirmMarkAsShipped(
        serialNumber: string,
        onConfirm: () => Promise<void>,
        onCancel?: () => void
    ): Promise<void> {
        return new Promise<void>((resolve) => {
            (window as any).swal({
                title: 'Are you sure?',
                text: `Do you want to mark the asset with serial #${serialNumber} as shipped?`,
                icon: "warning",
                closeOnClickOutside: false,
                className: "sn-m-modal",
                buttons: {
                    cancel: {
                        text: "No",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true
                    },
                    confirm: {
                        text: "Yes",
                        value: true,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-red",
                        closeModal: true
                    }
                },
                dangerMode: true,
            }).then(async (willMark: boolean) => {
                if (!willMark) {
                    if (onCancel) onCancel();
                    resolve();
                    return;
                }

                await onConfirm();
                Toastr.success("Asset marked as shipped", {
                    timeOut: 3000,
                    positionClass: 'toast-top-right'
                });
                resolve();
            });
        });
    }
}

